import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import InputText from '../../../components/InputText.jsx';
import TranslationText from '../../../components/Translation/TranslationText.jsx';
import { PasswordToggleIcon } from '../../../icons/PasswordToggleIcon';

export function PasswordInput({ model, errors, businessLogin, onChange }) {
  const [showPassword, setShowPassword] = useState(false);
  
  const hasError = (errors?.password?.length > 0) || (errors?.onLogin?.length > 0);

  const handleTogglePasswordShow = (e) => {
    e.preventDefault();
    setShowPassword(prev => !prev);
  };

  const handleKeyDown = (e) => {
    // Allow Enter and Space to toggle password visibility
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleTogglePasswordShow(e);
    }
  };

  return (
    <div className={`form-field password-form-field ${hasError ? '-has-error' : ''}`}>
      <label htmlFor="password" className="form-field__label">
        <TranslationText text="login_page_password_title" />
      </label>

      <div className="form-field-container">
        <InputText
          id="password"
          prop="password"
          className="form-field__input"
          value={model?.password || ''}
          onChange={onChange}
          type={showPassword ? "text" : "password"}
          autoComplete="current-password"
          aria-invalid={hasError}
          aria-describedby={hasError ? "password-error" : undefined}
        />
        <a
          href="#"
          className={`form-field__card-icon togglePassword ${showPassword ? 'show' : ''}`}
          onClick={handleTogglePasswordShow}
          onKeyDown={handleKeyDown}
          aria-label={showPassword ? "Hide password" : "Show password"}
          aria-pressed={showPassword}
          tabIndex={-1}
        >
          <PasswordToggleIcon />
        </a>
      </div>
      
      <div 
        id="password-error"
        className="sublabel error-msg show padding-bottom"
        role={hasError ? "alert" : undefined}
      >
        <TranslationText text={errors?.password} />
        {errors?.passwordValidation && (
          <span>{errors.passwordValidation}</span>
        )}
        <TranslationText text={errors?.onLogin} />
      </div>
    </div>
  );
}
